import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const TextAndVideo = () => import(/* webpackChunkName: "snippet-items-text-and-video" */ 'components/SnippetTemplate/Items/TextAndVideo')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(TextAndVideo, {props: eval(this.elemId)})
        })
    }
}
